//import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { appInsightService, reactPlugin } from './Services/AppInsightService';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AuthProvider } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";

import { AppLayout } from "./pages/layout/AppLayout";
import { HomeContent } from "./pages/home/homeContent";
import Characters from "./pages/Characters/Characters";
import Account from "./pages/Account/Account";
import About from "./pages/About/About";
//import CharCreate from "./components/Character/CharacterSheet/CharCreate";
import CharacterWorkshop from "./pages/Characters/CharacterWorkshop";

function TrackPageView() {
    const location = useLocation();
    useEffect(() => {
        const appInsights: ApplicationInsights | null = appInsightService;
        appInsights?.trackPageView({ name: location.pathname + location.search });      // If seeing duplicate entries in AppInsights this is probably logging what enableAutoRouteTracking tracks already.
    }, [location]);
    return null;
}

const App = () => {
    return (
        <AppInsightsErrorBoundary onError={() => <center><h1>Looks like something went wrong</h1>Refreshing the page usually fixes most issues.</center>} appInsights={reactPlugin}>
            <BrowserRouter>
                <TrackPageView />
                <AuthProvider>
                    <Routes>
                        <Route element={<AppLayout />}>
                            <Route path="/" element={<HomeContent />} />
                            <Route path="/about" element={<About />} />

                            <Route path="/characters" element={
                                <RequireAuth>
                                    <Characters />
                                </RequireAuth>
                                }
                            />

                            <Route path="/account" element={
                                <RequireAuth>
                                    <Account />
                                </RequireAuth>
                                }
                            />

                            <Route path="/characters/new" element={<RequireAuth><CharacterWorkshop /></RequireAuth>} />
                            <Route path="/characters/:charId/edit" element={<RequireAuth><CharacterWorkshop /></RequireAuth>} />
                            <Route path="/characters/:charId/view" element={<RequireAuth><CharacterWorkshop /></RequireAuth>} />

                            {/* future */}
                            {/*
                            <Route path="/play/:charId" element={
                                <RequireAuth>
                                    <GamePage />
                                </RequireAuth>
                                }
                            />
                            */}

                            <Route path="*" element={<h1>Page Not Found</h1>} />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </AppInsightsErrorBoundary>
    );
}

export default App;
